import {
    byLastName,
    byCompany,
    byHomeCity,
    byWorkCity,
    byRecentlyAdded,
    byRelevance,
    byName,
    byDeletedDate,
} from './personaListSortUtils.locstring.json';
import { sortOrderLabel, byFirstName } from '../strings.locstring.json';
import loc from 'owa-localize';
import { Sorting, AppState } from '../../appstate';
import { getPersonaListViewModel } from '../selectors/personaListViewModelSelector';

export function getFindPeopleSortingPath(appState: AppState): string {
    const personaListViewModel = getPersonaListViewModel(appState);
    const sorting = personaListViewModel?.sorting;

    switch (sorting) {
        case Sorting.ByCompany:
            return 'PersonaCompanyName';
        case Sorting.ByFirstName:
            return 'PersonaDisplayNameFirstLast';
        case Sorting.ByHomeCity:
            return 'PersonaHomeCity';
        case Sorting.ByWorkCity:
            return 'PersonaWorkCity';
        case Sorting.ByLastName:
            return 'PersonaDisplayNameLastFirst';
        case Sorting.ByRelevance:
            return 'PersonaRelevanceScore';
        case Sorting.ByStatus:
            return 'PersonaObjectStatus';
        case Sorting.ByLastChanged:
            return 'ProfileLastChanged';
        case Sorting.ByRecentlyAdded:
            return 'PersonaCreationTime';
        default:
            return 'PersonaDisplayNameLastFirst';
    }
}

export function toSortingName(sorting: Sorting): string {
    switch (sorting) {
        case Sorting.ByFirstName:
            return loc(byFirstName);
        case Sorting.ByLastName:
            return loc(byLastName);
        case Sorting.ByCompany:
            return loc(byCompany);
        case Sorting.ByHomeCity:
            return loc(byHomeCity);
        case Sorting.ByWorkCity:
            return loc(byWorkCity);
        case Sorting.ByRecentlyAdded:
            return loc(byRecentlyAdded);
        case Sorting.ByRelevance:
            return loc(byRelevance);
        case Sorting.ByName:
            return loc(byName);
        case Sorting.ByDeletedDate:
            return loc(byDeletedDate);
        default:
            return loc(sortOrderLabel);
    }
}

/**
 * Returns true if initials are to be shown in the list group headers, based on the current sort option. False if not.
 * @param viewState The view state to check
 */
export function isSortingWithInitials(sorting: Sorting): boolean {
    switch (sorting) {
        case Sorting.ByFirstName:
        case Sorting.ByLastName:
        case Sorting.ByName:
            return true;
        default:
            return false;
    }
}
